<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{row}">
        <el-tag
          size="mini"
          :type="
            row.planStatus === 'N'
              ? 'success'
              : row.planStatus === 'D'
              ? 'warning'
              : row.orderStatus === 'Y'
              ? 'primary'
              : 'light'
          "
        >
          {{ row.v_planStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{row}">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || 查看"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: {code: row.mrpPackagePlanCode},
                })
              "
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'

export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    openEditPage({pageType, params = {}}) {
      this.$router.push({
        name: 'plan-planPackage-detail',
        params: {...params, pageType},
      })
    },
  },
}
</script>
